import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    iframeContent: {
        height: '100%',
        width: '100%',
        transition: 'all 2000ms linear',
    },
}))
export interface GetIframeComponentProps {
    mdDown: boolean
    videoId: string
    videoSource: string
}

const IframeComponent = ({
    mdDown,
    videoId,
    videoSource,
}: GetIframeComponentProps) => {
    let iframElements = document.querySelectorAll('#iframeVideoCarouselViewer')
    const classes = useStyles()
    React.useEffect(() => {
        iframElements.forEach((item, index) => {
            item.setAttribute(
                'style',
                `translate:(0px,${index * 100});display:block`
            )
        })
    }, [iframElements])
    switch (String(videoSource).toLowerCase()) {
        case 'youtube':
            return (
                <iframe
                    id="iframeVideoCarouselViewer"
                    title="youtube-video"
                    className={clsx(
                        'listingDetailYouTubePlayer',
                        classes.iframeContent
                    )}
                    width={mdDown ? '352' : '640'}
                    height={mdDown ? '198' : '360'}
                    frameBorder={0}
                    allowFullScreen
                    src={`https://www.youtube.com/embed/${videoId}`}
                />
            )
        case 'vimeo': {
            return (
                <iframe
                    title="vimeo-video"
                    id="iframeVideoCarouselViewer"
                    className={clsx(
                        'listingDetailVimeoPlayer',
                        classes.iframeContent
                    )}
                    src={`https://player.vimeo.com/video/${videoId}`}
                    width={mdDown ? '352' : '640'}
                    height={mdDown ? '198' : '360'}
                    allowFullScreen
                    frameBorder={0}
                />
            )
        }
        default:
            return null
    }
}

export default IframeComponent
